module.exports = __webpack_public_path__ + "static/buddylee-f2941e6d3ca1d0d527c913387c4550d1.jpg";